import type {SxProps, Theme} from '@mui/material';

import {
  alignmentStatus,
  orangeColors,
  scorePill,
  semantic,
} from '../../../../../layouts/theme/designSystem';
import {getWorkforceProfileHighlightDotColor} from '../../utils/WorkforceProfileDetail/getWorkforceProfileHighlightDotColor';

export const gapsAndSignalsPaperSx: SxProps<Theme> = {
  border: `1px solid ${orangeColors[3]}`,
  borderRadius: '14px',
  p: 2.5,
};

export const gapsAndSignalsListRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  py: 0.75,
  borderBottom: `0.5px solid ${orangeColors[3]}`,
  '&:last-child': {borderBottom: 'none'},
};

export const gapsAndSignalsStrengthRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 1,
  py: 0.75,
  borderBottom: `0.5px solid ${orangeColors[3]}`,
  '&:last-child': {borderBottom: 'none'},
};

export const gapsAndSignalsDotSx = (variant: 'partial' | 'notMet' | 'strength'): SxProps<Theme> => ({
  width: 7,
  height: 7,
  borderRadius: '50%',
  flexShrink: 0,
  bgcolor:
    variant === 'strength'
      ? getWorkforceProfileHighlightDotColor('strong')
      : variant === 'partial'
        ? getWorkforceProfileHighlightDotColor('partial')
        : alignmentStatus.gapAccent,
  ...(variant === 'strength' && {mt: 0.75}),
});

export const gapsAndSignalsPartialGapChipSx: SxProps<Theme> = {
  height: 22,
  fontSize: 11,
  fontWeight: 600,
  bgcolor: scorePill.medium.bgcolor,
  color: scorePill.medium.color,
};

export const gapsAndSignalsNotMetChipSx: SxProps<Theme> = {
  height: 22,
  fontSize: 11,
  fontWeight: 600,
  bgcolor: alignmentStatus.gapChipBg,
  color: alignmentStatus.gapChipFg,
};

export const gapsAndSignalsRedeploymentChipSx: SxProps<Theme> = {
  bgcolor: semantic.info.bg,
  color: semantic.info.fg,
  fontWeight: 500,
};
